module.exports = __webpack_public_path__ + "static/media/linked-in-white.1d760ef1.svg";